import { Stack } from '@veeqo/ui';
import TitleGroup from 'components/common/TitleGroup';
import Layout from 'components/layout/Layout';
import { BackupCodeForm } from './components/LoginBackupVerificationForm';
import LoginAside from './components/LoginAside';
import { Container, FormContainer, Wrapper, } from './styled';

export const LoginBackupVerification = () => {
    return (
        <Layout showLogo showSignup asideContent={<LoginAside />}>
            <Wrapper>
                <Container>
                    <TitleGroup
                        showLoginReturnButton
                        loginReturnPath="../.."
                        title="Enter a backup code"
                        subtitle="Enter one of the backup codes you saved when you set up your authenticator app."
                    />
                    <Stack spacing={8}>
                        <FormContainer>
                            <BackupCodeForm />
                        </FormContainer>
                    </Stack>
                </Container>
            </Wrapper>
        </Layout>
    );
};
